import {useSyncExternalStore} from "react";

let height = 0;
const listeners = new Set<() => void>();

export const setDrawerHeight = (h: number) => {
  if (h === height) return;
  height = h;
  listeners.forEach((l) => l());
};

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const getSnapshot = () => height;

export const useDrawerHeight = () => useSyncExternalStore(subscribe, getSnapshot);
